import { useEffect } from 'react';
import Navigation from '../../home/components/Navigation';
import Footer from '../../home/components/Footer';
import CTA from '../../home/components/CTA';
import { industryServicesData } from '../../../mocks/industryServices';
import { useSEO, getServiceSchema } from '../../../utils/seo';

export default function HVACPage() {
  useSEO({
    title: 'Digital Marketing for HVAC Contractors | HVAC Marketing Services',
    description: 'Specialized digital marketing for HVAC contractors. Generate year-round leads with SEO, Google Ads, web design, and social media marketing. Dominate your local market and grow your HVAC business.',
    keywords: 'HVAC contractor marketing, HVAC marketing services, HVAC SEO, HVAC lead generation, HVAC contractor advertising',
    canonical: '/industries/hvac',
    schema: getServiceSchema(
      'Digital Marketing for HVAC Contractors',
      'Specialized marketing strategies designed to help HVAC contractors dominate their local market and generate consistent, high-quality leads year-round.'
    )
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToContact = () => {
    window.location.href = '/#contact';
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-black via-gray-900 to-black overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-red-600/10 via-transparent to-transparent"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-red-600 rounded-2xl mb-6">
              <i className="ri-temp-cold-line text-4xl text-white"></i>
            </div>
            <h1 className="font-heading text-5xl md:text-6xl font-bold text-white mb-6">
              Digital Marketing for HVAC Contractors
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Specialized marketing strategies designed to help HVAC contractors dominate their local market and generate consistent, high-quality leads year-round.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <button onClick={scrollToContact} className="inline-flex items-center px-8 py-4 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-all whitespace-nowrap cursor-pointer">
                Get Started <i className="ri-arrow-right-line ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="font-heading text-4xl md:text-5xl font-bold text-black mb-4">
              Services We Market For HVAC Contractors
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We understand your business and know how to attract customers for all your services
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {industryServicesData.hvac.map((service, index) => (
              <div key={index} className="bg-gray-50 p-6 rounded-xl hover:shadow-lg transition-all border-l-4 border-red-600">
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-red-600 text-xl flex-shrink-0 mt-1"></i>
                  <h3 className="font-heading text-lg font-semibold text-black">{service}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/81ce6b5fb360e75f0380bcb7e8fce573.jpg"
                alt="HVAC Contractor"
                className="w-full h-auto rounded-2xl shadow-2xl object-cover"
              />
            </div>
            <div>
              <h2 className="font-heading text-4xl md:text-5xl font-bold text-black mb-6">
                Why HVAC Contractors Choose Us
              </h2>
              <p className="text-xl text-gray-600 mb-8">
                We specialize in marketing for HVAC contractors and understand the seasonal nature of your business.
              </p>
              <div className="space-y-6">
                {[
                  { icon: 'ri-calendar-line', text: 'Generate leads year-round, not just peak season' },
                  { icon: 'ri-money-dollar-circle-line', text: 'Promote high-value system replacements' },
                  { icon: 'ri-repeat-line', text: 'Build recurring maintenance plan customers' },
                  { icon: 'ri-alarm-warning-line', text: 'Capture emergency service calls 24/7' },
                  { icon: 'ri-star-line', text: 'Build reputation with review management' }
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="w-8 h-8 bg-red-600 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${item.icon} text-white`}></i>
                    </div>
                    <p className="text-lg text-gray-700">{item.text}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <CTA />
      <Footer />
    </div>
  );
}
